<template>
  <div class="text-center mb-8">
    <h2 class="text-2xl md:text-3xl font-bold text-primary-dark mb-3">
      +1 milhão de pessoas já fizeram um mapa numerológico no Brasil
    </h2>
    <p class="text-gray-600">
      Veja o que algumas delas têm a dizer sobre a experiência
    </p>
  </div>
</template>